import { Capacitor } from '@capacitor/core';

export type Platform = 'web' | 'android' | 'ios';

export function getPlatform(): Platform {
  const p = Capacitor.getPlatform();
  if (p === 'android') return 'android';
  if (p === 'ios') return 'ios';
  return 'web';
}

export const platform: Platform = getPlatform();
export const isNative = Capacitor.isNativePlatform();
export const isWeb = !isNative;
